import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { brand } from '../config/brand';
import { switchLocalePath } from '../config/page-routes';

/**
 * Language switcher. Resolves the equivalent page in the target locale
 * using `page-routes.ts` so all URLs stay correct across pages.
 */
export function LanguageSwitcher() {
  const { pathname } = useLocation();
  const { t, i18n } = useTranslation();

  return (
    <nav aria-label={t('footer.language')} className="language-switcher">
      <ul>
        {brand.locales.map((l) => {
          const isActive = i18n.language.startsWith(l);
          return (
            <li key={l}>
              <Link
                to={switchLocalePath(pathname, l)}
                hrefLang={l}
                aria-current={isActive ? 'true' : undefined}
                aria-label={t('language.switchTo', { language: t(`language.${l}`) })}
              >
                {t(`language.${l}`)}
              </Link>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}
